import React, { useEffect, useRef, useState } from "react"
import trcss from "../../../styles/Telerecovery.module.css"
import { Tooltip } from "primereact/tooltip"
import { formatPhoneNumber, getRejectedReasonText, findName, formatDate, getTimeAgo } from "../Utils"
import { Button } from 'primereact/button'
import SendIcon from '../resources/send_white.svg'

export default function InvalidMessageChat({ selectedConvs, showMessageReply, staffNames }) {
  const [selectedConv, setSelectedConv] = useState(null)
  const messagesEndRef = useRef(null)

  const scrollToBottom = () => {
    messagesEndRef?.current?.scrollIntoView({ behavior: "smooth" })
  }

  useEffect(() => {
    if (selectedConvs.length === 1) {
      setSelectedConv(selectedConvs[0])
    } else {
      setSelectedConv(null)
    }

    setTimeout(() => scrollToBottom(), 500)

  }, [selectedConvs, staffNames])

  const showMsgBody = (message, classN) => {
    const dateClass = formatDate(message.sentAt, "MMMMdyyyyhmms")
    return (
      <div>
        <div
          className={classN + " " + dateClass}
        >
          {message.body}
        </div>
        <Tooltip target={"." + dateClass} className="custom-tooltip" position="top">
          <span>
            {formatDate(message.sentAt, "MMMM d yyyy, h:mm:ss a")}
          </span>
        </Tooltip>
      </div>
    )
  }

  const getStaffName = (staffId) => {
    if (staffNames && staffNames.length > 0) {
      const staff = findName(staffId, staffNames)
      return staff?.full_name ? staff.full_name : ""
    }
    return ""
  }

  const buildStaffMessage = (message, i) => {
    return (
      <li key={i} style={{ marginBottom: "15px" }}>
        <div className={trcss.messageData}
          style={{
            justifyContent: "flex-end",
            marginBottom: "5px"
          }}
        >
          <span className={trcss.messageDataTime}>
            {getStaffName(message.staffId)}{getTimeAgo(message.sentAt)}
          </span>
        </div>
        <div style={{ marginLeft: "2px", float: "right" }} className={trcss.chatMessageBody}>
          {showMsgBody(message, trcss.myMessage)}
        </div>
      </li>
    )
  }

  const buildParticipantMessage = (message, i) => {
    return (
      <li key={i} style={{ marginBottom: "15px" }}>
        <div className={trcss.messageData}>
          <div style={{ alignSelf: "center" }}>
            <span>{formatPhoneNumber(selectedConv.from)}</span>
            <span className={trcss.messageDataTime}>{getTimeAgo(message.sentAt)}</span>
          </div>
        </div>
        <div style={{ marginRight: "2px", marginTop: "5px", float: "left" }} className={trcss.chatMessageBody}>
          {showMsgBody(message, trcss.participantMessage)}
          {message.reason && message.reason !== "" &&
            <div>
              <span style={{ fontSize: "12px", color: "#999999" }}>{getRejectedReasonText(message.reason)}</span>
              <span style={{ fontSize: "12px", color: "#999999" }}>- Attempted to contact Staff {formatPhoneNumber(message.to)} {getStaffName(message.staffId)}</span>
            </div>
          }
        </div>
      </li>
    )
  }

  const showSelectedConv = () => {
    return (
      <div
        className={trcss.chatWindow}
      >
        <div className={trcss.chatWindowHeader}>
          <div>
            <span style={{ fontWeight: "600", fontSize: "12px" }}>{formatPhoneNumber(selectedConv.from)}</span>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
            {selectedConv.messages && selectedConv.messages.length > 0 && (
              <p style={{ fontSize: "11px", alignSelf: "center" }}>
                {`Last message: ${getTimeAgo(selectedConv.lastSentAt)}`}
              </p>
            )}
          </div>
        </div>
        <div className={trcss.chatHistoryContainer}>
          <ul className={trcss.chatWindowList} style={{ paddingTop: "10px" }}>
            {selectedConv.messages.map((message, i) => {
              if (message.type === "Message") {
                return buildParticipantMessage(message, i)
              } else {
                return buildStaffMessage(message, i)
              }
            })
            }
          </ul>
          <div ref={messagesEndRef}></div>
        </div>
        <div className={trcss.chatWindowFooter} style={{ flexDirection: "column", alignItems: "flex-end" }}>
          <Button
            label=""
            className={trcss.sendBtn_white}
            onClick={showMessageReply}
          >
            <span style={{ display: 'flex', alignItems: 'center' }}>
              <span style={{ marginRight: '0.5em' }}>Reply</span>
              <img src={SendIcon} alt="Send Icon" />
            </span>
          </Button>
        </div>
      </div>
    )
  }

  if (selectedConv)
    return showSelectedConv()

  if (selectedConvs.length > 1) {
    return (
      <div className={trcss.chatWindow}>
        <div className={trcss.chatWindowHeader}>
          <div>
            <span style={{ fontWeight: "600", fontSize: "12px" }}>Multiple Conversations</span>
          </div>
        </div>
        <div className={trcss.chatHistoryContainer} style={{ minHeight: "850px" }}>
          <ul className={trcss.chatWindowList} style={{ paddingTop: "10px" }}>
            {selectedConvs.map((conv, i) => {
              return (
                <li
                  key={i}
                  style={{ marginBottom: "15px", border: "1px solid #E7E0F1", borderRadius: "8px", padding: "16px" }}
                >
                  <div className={trcss.messageData}>
                    <div style={{ alignSelf: "center", display: "flex", gap: "15px" }}>
                      <span>{formatPhoneNumber(conv.from)}</span>
                      <span className={trcss.messageDataTime} style={{ marginLeft: "0px" }}>{getTimeAgo(conv.lastSentAt)}</span>
                      <span className={trcss.message_count}>{conv.messages.length}</span>
                    </div>
                  </div>
                  <div style={{ marginLeft: "2px", marginTop: "5px", marginBottom: "0px" }} className={trcss.chatMessageBody}>
                    {showMsgBody(conv.messages.length > 1 ? conv.messages[conv.messages.length - 1] : conv.messages[0])}
                  </div>
                </li>
              )
            })
            }

          </ul>
        </div>
      </div>
    )
  }

  return null
}